
        <div class="carousel__container">
            <div class="carousel__item">
                <img *ngIf="slide" src="{{ slide.ad_image_url }}" (click)="onClick(slide)" [attr.data-test-id]="'carouselImgUrl_' + counter" class="carousel__image">
            </div>
        </div>
    